











import queries from "@/gql/queries.coffee"
import EstablishmentStateComments from '@/components/EstablishmentStateComments'

export default {
  name: "EstablishmentAllMessage"
  components: {EstablishmentStateComments}
  data: ()->
    return {
      messages: []
    }
  props: {
    review:{
      type: Object
    },
    currentState: {
      type: Object
    },
  }
  mounted: ()->
    resp = await queries.run("get_all_message_for_review", [this.review.uid])
    #console.log("messages", resp.data.data.all_message_review.messages, currentState?)
    if currentState?
        @messages = resp.data.data.all_message_review.messages.filter (stateMessages)->
            return stateMessages.length > 0 && stateMessages[0].state_uid != currentState.uid
    else
        @messages = resp.data.data.all_message_review.messages
    #console.log("messages", @messages)
}
